const button = document.querySelector('.menu-button');
const nav = document.querySelector('#site-nav');
button?.addEventListener('click', () => {
  const open = nav.classList.toggle('open');
  button.setAttribute('aria-expanded', String(open));
});
nav?.addEventListener('click', () => {
  nav.classList.remove('open');
  button.setAttribute('aria-expanded', 'false');
});

(() => {
 const root=document.querySelector('.brand-scroller');
 if(!root)return;
 const viewport=root.querySelector('.brand-scroll-window');
 const track=root.querySelector('.brand-scroll-track');
 const group=root.querySelector('.brand-scroll-group');
 const clone=group.cloneNode(true);
 clone.setAttribute('aria-hidden','true');
 clone.querySelectorAll('a').forEach(a=>{a.removeAttribute('id');a.tabIndex=-1;});
 track.append(clone);
 const reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
 const toggle=root.querySelector('[data-brand-pause]');
 let manual=reduced.matches,hover=false,focused=false,touch=false,last=0,hold=0;
 function label(){toggle.textContent=manual?root.dataset.play:root.dataset.pause;toggle.setAttribute('aria-pressed',String(manual));}
 label();
 toggle.addEventListener('click',()=>{manual=!manual;label();});
 root.addEventListener('mouseenter',()=>hover=true);
 root.addEventListener('mouseleave',()=>hover=false);
 viewport.addEventListener('focusin',()=>focused=true);
 viewport.addEventListener('focusout',()=>{focused=viewport.contains(document.activeElement);});
 viewport.addEventListener('pointerdown',()=>touch=true);
 window.addEventListener('pointerup',()=>{touch=false;hold=performance.now()+2500;});
 viewport.addEventListener('wheel',()=>hold=performance.now()+3000,{passive:true});
 function move(direction){hold=performance.now()+3000;const width=group.getBoundingClientRect().width;if(direction<0&&viewport.scrollLeft<286)viewport.scrollLeft+=width;viewport.scrollBy({left:direction*286,behavior:reduced.matches?'instant':'smooth'});}
 root.querySelector('[data-brand-prev]').addEventListener('click',()=>move(-1));
 root.querySelector('[data-brand-next]').addEventListener('click',()=>move(1));
 reduced.addEventListener('change',()=>{manual=reduced.matches;label();});
 function frame(now){const delta=Math.min(now-last,50);last=now;
 if(!manual&&!hover&&!focused&&!touch&&!document.hidden&&now>hold){const width=group.getBoundingClientRect().width;viewport.scrollLeft+=delta*.035;if(width&&viewport.scrollLeft>=width)viewport.scrollLeft-=width;}
 requestAnimationFrame(frame);}
 requestAnimationFrame(frame);
})();

(() => {
  const reference = document.getElementById('brand-bluebirdie');
  const tile = document.getElementById('brand-fort-spunky');
  if (!reference || !tile) return;
  const matchHeight = () => {
    const height = reference.getBoundingClientRect().height;
    if (height > 0) tile.style.setProperty('--fso-matched-card-height', height + 'px');
  };
  matchHeight();
  if ('ResizeObserver' in window) new ResizeObserver(matchHeight).observe(reference);
  window.addEventListener('resize', matchHeight, {passive: true});
  window.addEventListener('load', matchHeight, {once: true});
  if (document.fonts?.ready) document.fonts.ready.then(matchHeight);
})();
